import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import PageWrap from '@components/PageWrap'
import BlockTitle from '@components/BlockTitle'
import BranchContactDetails from '@components/BranchContactDetails'
import BranchOpeningHours from '@components/BranchOpeningHours'
import BackLink from '@components/BackLink'
import { branchesRoute } from '@constants/routes'
import { ReactComponent as RedMarker } from '@assets/svgs/icons/marker_red.svg'
import { embedHours } from '@helpers/BranchesHelper'
import './Branch.module.scss'

// This is a class based component as
// Google Maps API will need to be consumed at a later date
// Please remove these comments when added
class Branch extends Component {
  state = {
    current: new Date().getDay()
  }

  render () {
    const { branch } = this.props
    const { current } = this.state

    if (R.not(branch)) {
      return null
    }

    const placeId = R.propOr('', 'placeId', branch)
    // set link to Google Maps
    const href = `https://www.google.com/maps/place/?q=place_id:${placeId}`
    // set embed map
    const base = 'https://www.google.com/maps/embed/v1/place'
    const key = typeof window !== 'undefined' ? window.config.GOOGLE_API_KEY : ''
    const src = `${base}?key=${key}&q=place_id:${placeId}`
    // add CFul hours into days object
    const days = embedHours(branch)

    return (
      <PageWrap>
        <BlockTitle title={R.propOr('', 'title', branch)} DynamicTag='h1' />
        <div styleName='directions'>
          <RedMarker />
          <span>
            <a href={href} target='_blank'>
              Get directions
            </a>{' '}
            (Google Maps)
          </span>
        </div>
        <section styleName='container'>
          <div styleName='cols'>
            <div styleName='detailsWrapper'>
              <BranchContactDetails
                address={R.propOr('', 'address', branch)}
                phone={R.propOr('', 'phone', branch)}
                email={R.propOr('', 'email', branch)}
              />
              <BranchOpeningHours days={days} current={current} />
            </div>
            <div styleName='mapWrapper'>
              <iframe src={src} />
            </div>
          </div>
          <div styleName='backlinkWrapper'>
            <BackLink to={branchesRoute} text='Back to branch list' />
          </div>
        </section>
      </PageWrap>
    )
  }
}

Branch.propTypes = {
  branch: PropTypes.object.isRequired
}

export default Branch



// WEBPACK FOOTER //
// ./src/containers/Branch/Branch.js